(function () {
  'use strict';
  if (window.__lavFSInit) return; window.__lavFSInit = true;

  var moneyFormat = window.__fsMoneyFormat || '{{amount}}';

  // Formatierung basierend auf shop.money_format
  function formatWithDelimiters(number, precision, thousands, decimal) {
    if (isNaN(number) || number == null) return '0';
    precision = Math.abs(precision) || 0;
    thousands = thousands || ',';
    decimal = decimal || '.';
    var parts = (number / 100).toFixed(precision).split('.');
    var integer = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    var decimals = parts[1] ? (decimal + parts[1]) : '';
    return integer + decimals;
  }

  function formatMoney(cents, format) {
    var fmt = format || moneyFormat;
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var match = fmt.match(placeholderRegex);
    var value;

    switch (match && match[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2, ',', '.'); break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'", '.'); break;
      default:
        // Fallback: wenn Shopify.formatMoney existiert, nutze sie.
        try {
          if (window.Shopify && typeof Shopify.formatMoney === 'function') {
            return Shopify.formatMoney(cents, fmt);
          }
        } catch(e){}
        value = (cents/100).toFixed(2);
    }
    return fmt.replace(placeholderRegex, value);
  }

  function pct(total, threshold){ if(!threshold||threshold<=0) return 100; return Math.max(0, Math.min(100, Math.round((total/threshold)*100))); }

  function updateEl(container, cart){
    var cfg = container.querySelector('template[data-fs-config]'); if(!cfg) return;
    var threshold = parseInt(cfg.dataset.threshold||'0',10);
    var textProgress = cfg.dataset.textProgress||''; var textSuccess = cfg.dataset.textSuccess||'';
    var total = cart && typeof cart.total_price==='number' ? cart.total_price : 0;
    var remaining = Math.max(0, threshold - total); var percent = pct(total, threshold);

    var fill = container.querySelector('[data-fs-fill]'); var text = container.querySelector('[data-fs-text]');
    if (fill) fill.style.width = percent + '%';
    if (remaining > 0) { if (text) text.textContent = textProgress.replace('%amount%', formatMoney(remaining, moneyFormat)); }
    else { if (text) text.textContent = textSuccess; if (fill) fill.style.width = '100%'; }
  }

  function getCart(){ return fetch('/cart.js',{credentials:'same-origin'}).then(function(r){return r.json();}); }

  function updateAll(){
    var nodes = document.querySelectorAll('.fs-wrap'); if(!nodes.length) return;
    getCart().then(function(cart){ nodes.forEach(function(n){ updateEl(n, cart); }); }).catch(function(){});
  }

  document.addEventListener('DOMContentLoaded', updateAll);
  document.addEventListener('shopify:section:load', updateAll);
  document.addEventListener('cart:updated', updateAll);
  document.addEventListener('cart:change', updateAll);

  (function(){ // XHR hook
    if (window.__lavFSXHR) return; window.__lavFSXHR = true;
    var X = window.XMLHttpRequest; if(!X) return; var open = X.prototype.open, send = X.prototype.send;
    X.prototype.open = function(m,u){ this.__u=(typeof u==='string'?u:''); return open.apply(this, arguments); };
    X.prototype.send = function(){ this.addEventListener('load', function(){ if (this.__u && /\/cart\//.test(this.__u)) setTimeout(updateAll,60); }); return send.apply(this, arguments); };
  })();

  (function(){ // fetch hook
    if (window.__lavFSFetch || !window.fetch) return; window.__lavFSFetch = true;
    var f = window.fetch; window.fetch = function(){ var i=arguments[0]; var u=(typeof i==='string')?i:(i&&i.url)||''; return f.apply(this, arguments).then(function(res){ if(u&&/\/cart\//.test(u)) setTimeout(updateAll,60); return res; }); };
  })();

  setTimeout(updateAll, 300);
})();
